// extracted by mini-css-extract-plugin
module.exports = {"confirmEmailWrap":"ConfirmEmail_confirmEmailWrap__1HAnI","column":"ConfirmEmail_column__1hR38","icon":"ConfirmEmail_icon__3SSGa"};